module.exports = __webpack_public_path__ + "static/media/bell-exclamation.974403ea.svg";